import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AppButtonComponent } from 'src/app/shared/components/app-button/app-button.component';
import { OsDetectService } from 'src/app/shared/services/os-detect.service';

@Component({
  selector: 'app-cookie-consent',
  standalone: true,
  imports: [CommonModule, AppButtonComponent],
  templateUrl: './cookie-consent.component.html',
  styleUrl: './cookie-consent.component.scss'
})
export class CookieConsentComponent implements OnInit {
  showCookieBanner: boolean = false;
  public styles: { [key: string]: string };

  @Output()
  public setCookies = new EventEmitter<void>();;

  buttonOptions = {
    buttonText: 'Eu Concordo',
    buttonBorderWidth: '1px',
    buttonSize: 'btn btn-md px-3 btn-secondary',
    borderRadius: '25px'
  };

  constructor(private osDetectService: OsDetectService) {}

  ngOnInit(): void {
    const acceptCookies = localStorage.getItem('accept-cookies');
    const isIos = this.osDetectService.isIOS();
    if (!acceptCookies && !isIos) {
      this.showCookieBanner = true;
    }

    this.styles = {
      '--primaryColor': localStorage.getItem('primaryColor') as string,
      '--secondaryColor': localStorage.getItem('secondaryColor') as string,
    };
  }

  acceptCookies(): void {
    localStorage.setItem('accept-cookies', 'true');
    this.showCookieBanner = false;
    this.setCookies.emit();
  }

  declineCookies(): void {
    this.showCookieBanner = false;
    this.setCookies.emit();
  }
}
